import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
} from '@angular/router';
import { isRestrictedMode } from './restricted-mode';

/**
 * Blocks vendors whose registration is not yet approved (restricted mode) from
 * full-portal routes. Restricted vendors keep chat, profile and registration editing.
 */
@Injectable({
  providedIn: 'root',
})
export class fullAccessGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree {
    if (isRestrictedMode()) {
      return this.router.createUrlTree(['profile']);
    }
    return true;
  }
}
